import React, { useState } from "react";
import Alert from "react-bootstrap/Alert";
import { ApiService } from "../../Component/services/apiServices";
import AccountHeader from "../../Component/Header/account_header";
import Footer from "../../Component/Footer";

function Changepassword() {
  const [errormsg, seterrormessage] = useState("");
  const [successmsg, setsuccessmsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [newpassword, setNewpassword] = useState("");
  const [confirmpassword, setconfirmpassword] = useState("");
  const changepassword = (e) => {
    e.preventDefault();
    if (newpassword === "" || newpassword === null) {
      seterrormessage("Please enter your New Pasword");
      return;
    }
    if (confirmpassword === "" || confirmpassword === null) {
      seterrormessage("Please enter your Confirm Password");
      return;
    }
    if (newpassword !== confirmpassword) {
      seterrormessage(
        "Your Confirm Password is not matched with New Password"
      );
      return;
    }
    setIsLoading(true);
    const dataString = {
      password: newpassword,
    };

    ApiService
      .postData('user-change-password', dataString)
      .then((res) => {
        if (res.status === "success") {
          setIsLoading(false);
          setsuccessmsg("Your Password has been changed!");
          setTimeout(() => {
            setsuccessmsg('')
            window.location.reload()
          }, 1000)
        } else if (res.status === 'session_expired') {
          localStorage.removeItem('USER_TOKEN')
          window.location.href = '/'
        }

        else {
          setIsLoading(false);
          seterrormessage(res.message);
          setTimeout(() => {
            seterrormessage('')
          }, 500)
          return false;
        }
      })
      .catch((error) => { });
  };
  return (
    <>
      <AccountHeader heading={'Change Password'}></AccountHeader>
      <div id="appCapsule">
      <div className="mwapper">
        <div className="p-3">
          <div className="row">
            {errormsg && (
              <Alert variant="danger">{errormsg}</Alert>
            )}
            {successmsg && <Alert variant="success">{successmsg}</Alert>}
            <div className="col-lg-12">
              <div className="form-group mb-3">
                <label htmlFor="user_fname">New Password</label>
                <input
                  type="password"
                  name="new_password"
                  className={`form-control required `}
                  placeholder="New Password"
                  onChange={(e) => {
                    seterrormessage('')
                    setsuccessmsg('')
                    setNewpassword(e.target.value);
                  }}
                  value={newpassword}
                />
              </div>
            </div>
            <div className="col-lg-12">
              <div className="form-group mb-3">
                <label htmlFor="user_fname">Confirm Password</label>
                <input
                  type="password"
                  value={confirmpassword}
                  name="confirm_password"
                  className={`form-control required `}
                  placeholder="Confirm Password"
                  onChange={(e) => {
                    seterrormessage('')
                    setsuccessmsg('')
                    setconfirmpassword(e.target.value);
                  }}

                />
              </div>
            </div>
            <div className="ccpanel-footer">
              <button
                className="btn btn-primary btn-full btn-lg mt-10"
                type="button"
                name="submit"
                onClick={(e) => {
                  changepassword(e);

                }}
                disabled={isLoading}
              >
                {isLoading ? (
                  <img src="/img/loder01.gif" width="60px" height="11px" alt="Daadi's Kitchen" />
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      </div>

      <Footer />
    </>
  );
}

export default Changepassword;
